import { render } from "./EditScontract.vue?vue&type=template&id=89267868"
import script from "./EditScontract.vue?vue&type=script&lang=js"
export * from "./EditScontract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__